export enum ProtectedFieldType {
  Unknown = -1,
  VersionsID = 0,
  ID = 1,
  RegistrationTime = 2,
  RegisteredOnBehalfOf = 3,
  Extension = 4,
  Size = 5,
  CreationDate = 6,
  VersionDate = 7,
  Title = 8,
  CompletedOn = 9,
  File = 10,

  Status = 11, // Extra property to know if instance is completed or not!

  EarliestDueDate = 12, //Property where we calculate the earliest due date based on the next steps list of the tasks

  RegistrationYear = 100,
  RegistrationMonth = 101,
  RegistrationQuarter = 102,
  RegisteredBy = 103,
  RegistrationYearWeek = 104,
  RegistrationWeek = 105,
  RegistrationYearMonth = 106,
  RegistrationYearQuarter = 107,

  PendingSteps = 150,

  DocumentStatus = 300, // aproved, waiting for publication, ..
  DocumentCheckinStatus = 301, // checkin,checkout
  DocumentFlow = 302, // to know in which flow it is right now
  ChangeReason = 303,

  MinorVersion = 350,
  MajorVersion = 351,
  Version = 352,

  PdfFile = 360, // must be hidden on the form

  // TRN
  SkillName = 404,

  GradeName = 406,
  GradeScore = 407,
  TrainingCategoryName = 408,
  SkillCategoryName = 409,
  TrainingName = 410,
  TrainingType = 411,
  TrainingDescription = 412,
  TrainingPrerequisites = 413,
  TrainingMaxParticipants = 414,
  TrainingResponsibes = 415,
  TrainingTargetFunctions = 416,
  TrainingSessionFrom = 417,
  TrainingSessionType = 418,
  TrainingSessionSubscribedUsers = 419,
  DocColDistributeOrgChart = 420,
  CostsName = 421,
  CostsDescription = 422,
  CostsPrice = 423,
  TrainingLocation = 424,
  TrainingSubscriptionType = 425,
  TrainingEvaluationType = 426,
  TrainerName = 427,
  TrainerType = 428,
  TrainerOrgChart = 429,
  TrainingSessionLessonFrom = 430,
  TrainingSessionLessonTo = 431,
  TrainingSessionLessonRemarks = 432,
  TrainingSessionTo = 433,
  SkillExpiracyType = 434,
  SkillExpiracyDays = 435,

  ExamCategoryName = 436,

  ExamName = 405,
  ExamDescription = 437,
  ExamTargetAudience = 438,
  ExamReadyForPublicationFlag = 439,
  ExamIsPublishedFlag = 440,
  ExamAmountOfQuestions = 441,
  ExamAmountOfAnswersPerQuestion = 442,
  ExamManager = 443,
  ExamCreator = 444,

  ExamSessionExaminee = 445,
  ExamSessionScore = 446,
  ExamSessionOrigin = 447,
  ExamSessionProgress = 448,

  ExamQuestionsAnswersQuestionID = 449,
  ExamQuestionsAnswersAnswerID = 450,
  ExamQuestionAnswerQuestionCaption = 451,
  ExamQuestionAnswerAnswerCaption = 452,
  ExamQuestionAnswerScore = 453,

  ExamScoreEvaluations = 454,
  ExamQuestionAnswerMaxPossibleScore = 455,
  ExamShowResultToExaminee = 456,

  TrainingSessionEvaluationType = 457,
  AnswerScorePercentage = 458,
  QualificationCategoryName = 459,
  QualificationCategoryTimeRange = 460,
  QualificationName = 461,
  QualificationExpiryType = 462,
  QualificationExpiryValue = 463,
  ExamQualificationTresholdScore = 466,
  SkillQualificationNoneOption = 467,
  QualificationQualificationsCrosslinkComment = 469,
  FunctionQualificationMandatory = 470,
  FunctionQualificationComment = 471,
  FunctionQualificationArchived = 472,
  UserQualificationFrom = 473,
  UserQualificationArchived = 474,
  UserQualificationAchievedOn = 475,
  UserQualificationExpiresOn = 476,
  UserQualificationInfinite = 477,
  UserQualificationComment = 478,
  UserQualificationOriginsId = 479,
  UserQualificationAchieved = 480,
  SignatureOptions = 468,
  // AI costs
  AiModel = 500,
  AiInputTokens = 501,
  AiOutputTokens = 502,
  AiTotalTokens = 503,
  AiProcessResponseStatus = 504,
  AiDay = 505,
  AiInputPriceInUsDollars = 506,
  AiOutputPriceInUsDollars = 507,
  AiType = 508,
  AiCallUniqueID = 509,
  AiCorrelationUniqueID = 510,
  AiTotalPriceInUsDollars = 511,
  AiIsRetry = 512,
  AiCallResponseStatus = 513,

  // Usage meter
  UsageMeterTypeKey = 514,
  UsageMeterEventCredits = 515,
  UsageMeterTypeValue = 516,
  UsageMeterEventUniqueId = 517,
  UsageMeterPeriodUniqueID = 518,
  UsageMeterEventUserID = 519,
  UsageMeterEventFeature = 520,
  UsageMeterEventComponentName = 521,

  // Checklists range 600 - 699
  // Question Categories
  ChkQuestionCategory = 600,

  // Checklist Templates
  ChkTemplateName = 601,
  ChkTemplateDescription = 602,
  ChkTemplateIsPossibleAnswerNA = 603,
  ChkTemplateIsAttachmentRequiredWhenNA = 604,
  ChkTemplateIsRemarkRequiredWhenNA = 605,
  ChkTemplateIsPossibleAnswerNC = 606,
  ChkTemplateIsAttachmentRequiredWhenNC = 607,
  ChkTemplateIsRemarkRequiredWhenNC = 608,
  ChkTemplatePassScore = 609,

  // Questions
  ChkQuestion = 610,
  ChkQuestionExtraInfo = 611,
  ChkQuestionDescription = 648,
  ChkQuestionTemplateSpecific = 612,
  ChkQuestionMaxScore = 613,
  ChkQuestionOrder = 614,
  // Phase 2 - ChkQuestionRequiresSeparateExecutor 615,
  // Phase 2 -  ChkQuestionDefaultExecutor 616,

  // CrosslinkFields
  ChkTemplateQuestionCrosslinkOrderID = 617,
  __Unused__ChkMainQuestionCrosslinkOrderID = 618,

  ChkTemplateQuestionCrosslinkMaxScore = 619,

  ChkTemplateQuestionCrosslinkGroupCombobox = 621,

  ChkTemplateQuestionCrosslinkIsPossibleAnswerNA = 623,

  ChkTemplateQuestionCrosslinkIsPossibleAnswerNC = 625,

  ChkTemplateQuestionCrosslinkIsRemarkRequired = 649,

  ChkTemplateQuestionCrosslinkIsAttachmentRequired = 650,

  // Result Class
  ChkResultClassType = 628,
  ChkResultClassName = 629,
  ChkResultClassValues = 630,
  ChkResultClassQuestionSpecific = 651,
  ChkResultClassCanvas = 652,

  // Attachments
  ChkAttachmentExtension = 632,
  ChkAttachmentTitle = 633,
  ChkAttachmentFile = 634,

  // Checklist Question And Answers
  ChkQAQuestionCaption = 635,
  ChkQAAnswerCaption = 636,
  ChkQAResultClassValueID = 654,
  ChkQANumericAnswerRange = 655,
  ChkQAAnswerMaxPossibleScore = 637,
  ChkQAAnswerScore = 638,
  ChkQAScorePercentage = 639,
  ChkQAPositiveNegative = 640,
  ChkQARemarks = 643,  // Adjusted for continuity

  ChkMainTemplatesCrosslinkTotalScore = 644,
  ChkMainTemplatesCrosslinkTotalMaxScore = 645,
  ChkMainTemplatesCrosslinkTotalPercentageCore = 646,

  ChkQaCanvas = 647,
  ChkQaUniqueRelationID = 653,
  ChkQaAnswerNumeric = 656,

  ChkMainQuestionCrosslinkOrderID = 657,
  ChkMainQuestionCrosslinkMaxScore = 658,
  ChkMainQuestionCrosslinkIsPossibleAnswerNA = 660,
  ChkMainQuestionCrosslinkIsPossibleAnswerNC = 661,
  ChkMainQuestionCrosslinkIsRemarkRequired = 662,
  ChkMainQuestionCrosslinkIsAttachmentRequired = 663,

  ChkQuestionIsArchived = 664,
  ChkResultClassIsArchived = 670,
  ChkResultClassRevisionVersion = 665, // optional

  ChkMainQuestionCrosslinkAttachmentRequiredWhenNa = 666,
  ChkMainQuestionCrosslinkAttachmentRequiredWhenNc = 667,
  ChkMainQuestionCrosslinkRemarksRequiredWhenNa = 668,
  ChkMainQuestionCrosslinkRemarksRequiredWhenNc = 669,
  QualificationSkillCrosslinkSkillGrade = 670,
  QualificationCertificateIsInactive = 671,
  // End checklists range


  UserFirstName = 1000,
  UserLastName = 1001,
  UserEmail = 1002,
  FunctionName = 2000,
  DepartmentName = 3000,
  DepartmentType = 3001,
  RoleName = 4000

}